module.exports = "<p>{{t('actionWebFiltersTitanHq.wanWebFiltersDns')|e}}</p>\n";
